// 세션 무대(`.stage`) 위에 떠 있는 패널이 **무대로 이벤트를 흘리지 않게** 끊는 공통 속성.
//
// 🔴 왜 필요한가 — 무대는 두 가지를 한다:
//   ① `onClick` 으로 **숨은 IME 입력칸(`ime-capture`)에 포커스를 되돌린다**(원격 키 입력을 받기 위해)
//   ② `<video>` 의 마우스 이벤트를 **원격 입력으로 주입**한다
// 패널(파일·채팅)은 무대 **안에** 놓여 있으므로(위치 기준이 무대라서), 패널 안을 눌러도
// 클릭이 무대까지 버블링해 ①이 돌아간다. 그러면 **패널의 입력칸을 눌러 포커스를 준 직후
// 곧바로 빼앗겨** 글자를 칠 수 없고, 친 글자는 원격으로 새어 나간다.
//
// ⚠️ `onMouseDown` 만 끊는 것으로는 부족하다 — `mousedown` 의 `stopPropagation()` 은
//    뒤따르는 **`click` 의 버블링을 막지 못한다**. 실제로 채팅 패널이 `onMouseDown` 하나만
//    끊고 있어 "입력칸을 눌러도 포커스가 안 간다" 는 결함이 있었다(2026-09-23 Mac 육안에서 발견).
//    시험이 못 잡은 이유: 자동 시험은 값을 `fill()` 로 넣어 **클릭 경로를 한 번도 지나지 않았다.**
//
// ⚠️ 키보드는 여기서 끊지 않는다 — 입력칸마다 조건이 다르기 때문이다(예: 채팅은 Enter 로 보내고
//    Shift+Enter 로 줄바꿈). 각 입력칸이 `onKeyDown`/`onKeyUp`/`onPaste` 에서 직접 끊는다.
import type { SyntheticEvent } from 'react';

const stop = (e: SyntheticEvent) => e.stopPropagation();

export const stageIsolationProps = {
  onClick: stop,
  onMouseDown: stop,
  onMouseUp: stop,
  onMouseMove: stop,
  onWheel: stop,
  onContextMenu: stop,
} as const;
